module.exports = __webpack_public_path__ + "static/media/logo_white.162d54b5.svg";